import gql from 'graphql-tag';
import { locationFieldsFragment, sanityDocumentFieldsFragment } from '@graphql/admin/fragments';

export const updateLocationMutation = gql`
  mutation UpdateLocation($id: ID!, $input: UpdateLocationInput!) {
    updateLocation(id: $id, input: $input) {
      ...AdminSanityDocumentFields
      ...AdminLocationFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${locationFieldsFragment}
`;